export default __webpack_public_path__ + "static/fXUQtTSX-b25dcbe4de8b6ef443c92e1045f6076d.svg";